import * as React from 'react';
import withStyles, { StyledComponentProps } from 'react-jss'
import * as classNames from 'classnames';
import stylesheet, { linkGutter, directions } from 'src/Constants/stylesheet';
import responsive from 'src/Constants/responsive';
import spacing from 'src/Constants/spacing';
import { InjectedAppProps, withApp } from 'src/_context/App';
import { Link, RouteComponentProps, withRouter } from 'react-router-dom';
import { Language } from 'src/_helpers/Languages';
import fonts from 'src/Constants/fonts';

export type DownloadPageProps = {
    page: DownlaodPageDto
};

const styles = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        ...stylesheet.MarginGutter(1, directions.sides)
    },
    submenuContainer: {
        display: 'flex',
        flex: '0',
        [responsive.Mobile]: {
            paddingTop: spacing.ContentGutter.Mobile,
            paddingBottom: spacing.ContentGutter.Mobile
        },
        [responsive.AfterMobile]: {
            paddingTop: spacing.ContentGutter.Desktop,
            paddingBottom: spacing.ContentGutter.Desktop
        }
    },
    faker: {
        flex: 0,
        whiteSpace: 'nowrap',
        opacity: 0,
        pointerEvents: 'none',
        [responsive.Mobile]: {
            display: 'none'
        },
        [responsive.AfterMobile]: {
            marginRight: linkGutter.AfterMobile
        }
    },
    submenu: {},
    submenuLink: {
        display: 'block'
    },
    content: {
        flex: '1',
        overflow: 'auto',
        overflowScrolling: 'touch',
        [responsive.Mobile]:
        {
            // marginRight: -(spacing.Gutter.Mobile)
        },
        [responsive.AfterMobile]:
        {
            marginRight: -(spacing.Gutter.Desktop),
            paddingLeft: 175 - (spacing.Gutter.Desktop)
        }
    },
    contentInner: {
        maxWidth: spacing.MaxWidthText,
        [responsive.Mobile]:
        {
            paddingBottom: (spacing.Gutter.Mobile)
        },
        [responsive.AfterMobile]:
        {
            paddingBottom: (spacing.Gutter.Desktop)
        }
    },
    linkFile: {
        '&:hover': {
            display: 'block'
        }
    },
    active: {
        ...fonts.ExcelsiorLTItalic
    }
}
type Props =
    InjectedAppProps &
    DownloadPageProps &
    RouteComponentProps<any> &
    StyledComponentProps<keyof typeof styles>;

type State = {
};

class DownloadPage extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
        }
    }

    public render() {
        const { classes, appContext: { app }, page: { Files }, location: { pathname } } = this.props;

        return (
            <div className={classNames(classes!.container)}>
                <div className={classes!.submenuContainer}>
                    {app && app.Menus.map(menu => {
                        const submenus = menu.Submenus;
                        if (submenus.length <= 0) { return }
                        return (
                            <React.Fragment key={menu.UID}>
                                <div className={classes!.faker}>{menu.Title}</div>
                                <div className={classes!.submenu}>
                                    {submenus.map(s => {
                                        const path = `/${Language}/${menu.UID}/${s.UID}`;

                                        return (
                                            <Link
                                                to={path}
                                                key={`${s.UID}`}
                                                className={
                                                    classNames(classes!.submenuLink,
                                                        pathname === path ? classes!.active : null)
                                                }
                                            >
                                                {s.Title}
                                            </Link>);
                                    })}
                                </div>
                            </React.Fragment>
                        );
                    })}
                </div>
                <div className={classes!.content}>
                    <div className={classes!.contentInner}>
                        {Files.map(f =>
                            <div key={f.File.Id}>
                                <a
                                    href={f.File.Src}
                                    target="_blank"
                                    className="linkFile"
                                >
                                    — {f.Title}
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default withStyles(styles)(withRouter(withApp((DownloadPage))));


// WEBPACK FOOTER //
// ./src/Components/DownloadPage.tsx